import { QUERY_STALE_TIME_MS } from 'further-ui/config';
import api from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';

export type FormData = {
  title?: string;
  summary?: string;
  letter?: string;
  notes?: string;
  supportingFiles?: Array<{
    name: string;
    path: string;
  }>;
};

type Params = {
  id?: string;
  onDeleteSuccess?: () => void;
};

const useExitStatement = ({ id, onDeleteSuccess }: Params) => {
  const handleMutation = useHandleTrpcMutation();

  return {
    createExitStatement: api.exitStatement.create.useMutation(
      handleMutation({
        successMessage: 'Exit statement created successfully.',
        refetchType: 'none',
      }),
    ),

    updateExitStatement: api.exitStatement.update.useMutation(
      handleMutation({
        successMessage: 'Exit statement updated successfully.',
        refetchType: 'none',
      }),
    ),

    deleteExitStatement: api.exitStatement.delete.useMutation(
      handleMutation({
        successMessage: 'Exit statement deleted successfully.',
        onSuccess: () => onDeleteSuccess?.(),
      }),
    ),

    exitStatement: api.exitStatement.get.useQuery(
      { exitStatementId: id! },
      {
        enabled: !!id,
        staleTime: QUERY_STALE_TIME_MS,
      },
    ),
  };
};

export default useExitStatement;
